import { posthog } from "posthog-js";
import type { ComponentChildren } from "preact";
import { useErrorBoundary } from "preact/hooks";
import { reportRenderError } from "./errorReporting.ts";

const reportError = (error: unknown) => {
  console.error("Uncaught render error:", error);
  posthog.captureException(error, { source: "AppErrorBoundary" });
  reportRenderError(error);
};

const reload = () => globalThis.location.reload();

const fallback = (
  <div className="flex flex-col items-center justify-center gap-4 flex-1 py-20 text-center">
    <h1 className="text-xl font-semibold text-text-primary-light dark:text-text-primary">
      Something went wrong
    </h1>
    <p className="text-text-secondary-light dark:text-text-secondary max-w-md">
      We hit an unexpected error and our team has been notified. Please reload
      the page to try again.
    </p>
    <button
      type="button"
      onClick={reload}
      className="rounded-lg bg-accent hover:bg-accent-hover px-4 py-2 font-medium text-white cursor-pointer transition-colors"
    >
      Reload
    </button>
  </div>
);

export const AppErrorBoundary = (
  { children }: { children: ComponentChildren },
) => {
  const [error] = useErrorBoundary(reportError);
  return error ? fallback : <>{children}</>;
};
